import { a as get } from "./utils2.mjs";

//#region src/api/instance-version-history.ts
const getFirstAdoptionDate = async (context, version) => {
	const { data } = await get(context.baseUrl, "/instance-version-history/first-adoption", version);
	return data.date;
};

//#endregion
export { getFirstAdoptionDate as t };
//# sourceMappingURL=instance-version-history.mjs.map